//sample data
const sampleData={
    leftSide:{
        photo:'/images/bikash_pic.png',
        phone:'+358 44 0000',
        email:'bikashweb@gmail.com',
        address:'Helsinki,Finland',
        websites:[
            {
                order:1,
                id:1,
                label:'Linkedin',
                url:'https://linkedin.com/in/example'
            },
            {
                order:2,
                id:2,
                label:'Github',
                url:'https://linkedin.com/in/example'
            },
            {
                order:3,
                id:3,
                label:'Portfolio',
                url:'https://linkedin.com/in/example'
            },
        ],
        sections:[
           {
                order:1,
                id:1,
                title:'Languages',
                rows:[
                    {
                        order:1,
                        id:1,
                        label:'English - Native',
                        link:'',
                    },
                    {
                        order:2,
                        id:2,
                        label:'German - Fluent',
                        link:'',
                    }
                ],
            },
           {
                order:2,
                id:2,
                title:'Certifications',
                rows:[
                    {
                        order:1,
                        id:1,
                        label:'Full-stack(Udemy, 2020)',
                        link:'https://udemy.com/certi',
                    },
                    {
                        order:2,
                        id:2,
                        label:'Full-stack(Udemy, 2022)',
                        link:'https://udemy.com/certi',
                    },
                    
                ],
            },
           {
                order:3,
                id:3,
                title:'Skills',
                rows:[
                    {
                        order:1,
                        id:1,
                        label:'Rapid Coding',
                        link:'',
                    },
                    {
                        order:2,
                        id:2,
                        label:'Team management',
                        link:'',
                    },    
                ],
            },
           {
                order:4,
                id:4,
                title:'Hobbies',
                rows:[
                    {
                        order:1,
                        id:1,
                        label:'Biking',
                        link:'',
                    },
                    {
                        order:2,
                        id:2,
                        label:'Computer games',
                        link:'',
                    },    
                ],
            },
        ],
    },
    rightSide:{
        fullName:'Bikash Web.',
        jobTitle:'Full Stack Development',
        profileSummary:'This is a short summary for Bikash web cv maker. This cv maker is good to use for everyone. ',        
        sections:[
           {
                order:1,
                id:1,
                title:'Experience',
                rows:[
                    {
                        order:1,
                        id:1,
                        title:'Web developer',
                        subTitle:'Company Name | StockHolm | June 2020- present',
                        details:[
                            {
                                order:1,
                                id:1,
                                detail:'This is something good'
                            },
                            {
                                order:2,
                                id:2,
                                detail:'This is something good'
                            }
                        ]                       
                    },                    
                ],
            }
        ],

    },
    branding:{
        leftBg:"#E2DEDF",
        rightBg:'#FFFFFF',
        fontDark:'#444446',
        fontLight:'#5C5C5D',
        lineSeperator:'#16A3F2',

    }
}

export default sampleData